const t = "YYYY-MM-DD", e = {
  date: "date",
  startDate: "startDate",
  endDate: "endDate"
};
export {
  e as DEFAULT_FIELD_NAME,
  t as INPUT_VALUE_FORMAT
};
//# sourceMappingURL=DatePicker.constants.es.js.map
